import { Component, Input, OnInit } from '@angular/core';
import { fadeIn } from 'src/app/animations';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
	animations: [fadeIn(200)]
})
export class LoaderComponent implements OnInit {

	@Input() public isLoadingFailed: boolean = null;
	@Input() public loaderMessage: string = null;
	@Input() public matIconFailed: string = null;
	@Input() public isInline = false;
	@Input() public hasTransparency = false;
	@Input() public isHorizontalLoader = false;

	constructor() { }

	ngOnInit() { }

}
